import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { FormState } from '@shared';

import { UserInvitation } from '@account-users/account/models/UserInvitation';

@Component({
  selector: 'app-invite-user-modal',
  templateUrl: './invite-user-modal.component.html',
  styleUrls: ['./invite-user-modal.component.scss'],
})
export class InviteUserModalComponent {
  @Input() state: FormState;
  @Input() errorResponse: HttpErrorResponse;
  @Output()
  inviteUser = new EventEmitter<UserInvitation>();

  constructor(public activeModal: NgbActiveModal) {}

  onSubmit(email) {
    this.inviteUser.emit(email);
  }
}
